import * as React from 'react'
import { styled, css } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import { AuthSection, AuthSectionProps } from '../../AuthSection'
import { SearchDrawer } from '../../drawers/SearchDrawer'
import * as S from '../../style'

type RightZoneProps = {
  search: {
    action: string
  }
} & AuthSectionProps

export function Crowdfunding({ loadUserExtraData, search, user }: RightZoneProps): React.ReactElement<RightZoneProps> {
  const $separator = React.useRef<HTMLDivElement>(null)

  const breakpointType = S.INTERMEDIATE_BREAKPOINT_TYPE

  return (
    <>
      <SearchDrawer
        action={search.action}
        siblingRef={$separator}
        user={user ? { unreadMessagesCount: user.unreadMessagesCount } : undefined}
      />
      <SeparatorContainer $breakpoint={breakpointType} ref={$separator} />
      <AuthSection loadUserExtraData={loadUserExtraData} user={user} />
    </>
  )
}

const SeparatorContainer = styled.div<{ $breakpoint: S.BreakpointType }>`
  padding: 0 22px 0 0;
  visibility: hidden;

  ${({ $breakpoint }) => {
    if ($breakpoint === 'custom') {
      return css`
        @media screen and ${S.CUSTOM_INTERMEDIATE_BREAKPOINT} {
          visibility: visible;
        }
      `
    }
    if ($breakpoint === 'laptop') {
      return css`
        @media screen and ${plume.BREAKPOINTS.LAPTOP} {
          visibility: visible;
        }
      `
    }
  }}
`
